import React from 'react'
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from "../../helper/controlservice";
import _ from 'lodash';
import { RefreshComponentOnClose } from '../Button/_private';

function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        setreload: (bool) => dispatch(formsAction.setreload(bool)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});

class CheckboxList extends React.PureComponent {
    state = {
        apiData: [],
        isApiCalling: true,
        touched: false,
        show: true,
        IsOtherSelected: false,
        control: {},
        value: [],
        apiDataBind: []
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var apiData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {}
        if (nextProps.control.binddatawithmodel && JSON.stringify(apiData[nextProps.control.bindmodelkey]) !== JSON.stringify(prevState.apiDataBind)) {
            return {
                apiDataBind: Array.isArray(apiData[nextProps.control.bindmodelkey]) ? apiData[nextProps.control.bindmodelkey] : [],
                control: nextProps.control
            };
        } else if (nextProps.control != prevState.control) {
            return {
                control: nextProps.control
            };
        }
        else return null;
    }
    componentDidUpdate(prevProps, prevState) {
        const { control } = this.state;
        if (control != prevState.control) {
            this.DataBind();
        } else if (control.binddatawithmodel) {
            if (!_.isEqual(this.state.apiDataBind, prevState.apiDataBind)) {
                this.DataBind(this.state.apiDataBind);
            }
        }
        var prevProp = prevProps.data[prevProps.formid];
        var currData = this.props.data[this.props.formid];
        if (prevProp && currData && prevProp[this.props.control.key] != currData[this.props.control.key]) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    componentDidMount() {
        ControlService().controlVaildationCheck(this.props);
        this.DataBind(this.state.apiDataBind);
    }
    DataBind(apiData) {
        const { control, formid } = this.props;
        debugger;
        if (control.databind == "API")
            this.ApiCall();
        else {
            let optionlist = []
            if (control.binddatawithmodel && apiData) {
                optionlist = apiData;
            } else if (control.dynamicdatabinding) {
                var num = data[formid] && data[formid][control.dynamicrecord] ? data[formid][control.dynamicrecord] : control.dynamicrecord;
                for (let i = 1; i <= num; i++) {
                    let arr = {};
                    arr[control.textfield] = i;
                    arr[control.valuefield] = i;

                    optionlist.push(arr);
                }
            } else {
                optionlist = control.optionlist;
            }
            this.setState({
                apiData: this.getData(optionlist),
                isApiCalling: false,
                IsOtherSelected: false
            }, () => this.forceUpdate());
        }
    }
    getData(dataoptions) {
        const { control, formid, data } = this.props;
        var _data = data[formid] && Array.isArray(data[formid][control.key]) ? data[formid][control.key] : [];

        var _dataoptions = ControlService().deepcopy(dataoptions);

        for (let i = 0; i < _dataoptions.length; i++) {
            if (typeof _dataoptions[i] === 'object') {
                if (_data.find(x => x[control.valuefield] === _dataoptions[i][control.valuefield])) {
                    _dataoptions[i].checked = true;
                } else {
                    _dataoptions[i].checked = false;
                }
            }
        }
        if (control.allowother && _dataoptions.length > 0) {
            var otheroption = ControlService().deepcopy(_dataoptions[0]);
            otheroption[control.textfield] = "Other";
            otheroption[control.valuefield] = "Other";
            otheroption.checked = false;
            _dataoptions.push(otheroption);
        }

        if (Array.isArray(_data)) {
            for (let i = 0; i < _data.length; i++) {
                let item = _data[i];
                var option = _dataoptions.filter(x => x[control.valuefield] == item);
                if (option.length == 0 || item == "Other") {
                    if (_dataoptions.find(x => x[control.textfield] == "Other")) {
                        this.setState({ IsOtherSelected: true });
                        _dataoptions.find(x => x[control.textfield] == "Other")[control.valuefield] = item;
                        _dataoptions.find(x => x[control.textfield] == "Other").checked = true;
                    }
                }
                else if (option.length > 0) {
                    _dataoptions.find(x => x[control.valuefield] == item).checked = true;
                }
            }
        }

        return _dataoptions;
    }

    ApiCall() {
        var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {}
        ControlService().ServiceRequest(this.props.control.apiurl, this.props.control.optionlist, this.props.control, this.props.token, data)
            .then(res => {
                var result = [];
                if (this.props.control.responsefield) {
                    if (Array.isArray(res) && res.length > 0) {
                        res = res[0];
                    }
                    result = res ? res[this.props.control.responsefield] : [];
                } else {
                    result = res;
                }
                this.setState({
                    apiData: this.getData(result),
                    isApiCalling: false
                });
            })
            .catch(err => {

                this.setState({
                    apiData: this.getData([]),
                    isApiCalling: false
                });
                console.log(err);
            });
    }
    onSelectionsChange(e, apiData, key) {
        const { control, formid } = this.props;
        var Items = [];
        var ObjItems = [];
        apiData.map(item => {
            if (item.checked) {
                Items.push(item[control.valuefield]);
                ObjItems.push(item);
            }
        })
        if (this.props.control.allowother) {
            if (e !== 'Other' && key === 'Other') {
                this.setState({ IsOtherSelected: e.target.checked })
            }
        }
        this.setState({ apiData: apiData })
        if (control.storejsonnode) {
            this.props.update(control.key, ObjItems, formid);
        } else {
            this.props.update(this.props.control.key, Items, formid);
        }
        ControlService().controlVaildationCheck(this.props)

        if (Array.isArray(control.refreshcomponentsonchange) && control.refreshcomponentsonchange.length > 0) {
            control.refreshcomponentsonchange.forEach(refreshcomponent => {
                let _control = {
                    refreshcomponentonclose: refreshcomponent,
                    refreshcomponenformid: control.refreshcomponenformid
                }
                RefreshComponentOnClose(_control, formid, this.props);
            })
        }
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    render() {
        const { control, action, formid } = this.props;

        var apiData = Array.isArray(this.state.apiData) ? this.state.apiData : [];

        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);

        // apiData.map(item => {
        //     data.push({ "label": item[this.props.control.textfield], "value": item[this.props.control.valuefield] })
        // })
        let checkboxList = apiData.map((s, i) => {
            if (control.direction == 'displayImage') {
                return (
                    <React.Fragment>
                        <div key={s[control.valuefield]} className={(control.noofcheckbox ? 'col-md-' + control.noofcheckbox : '3 col-6')}>
                            <div className={'check-img ' + (control.leftimg ? ' left-img ' : ' top-img ')}>
                                <label className="check-img-control">
                                    <input aria-label={s[control.valuefield]} className="check-img-input" type="checkbox" value={s[control.valuefield]}
                                        checked={s.checked}
                                        onChange={(e) => { apiData[i].checked = e.target.checked; this.onSelectionsChange(e, apiData, s[control.textfield]) }}
                                        onBlur={() => { this.handleBlur(); }}
                                        disabled={this.props.disabled} />
                                    <span className={'d-flex ' + (control.leftimg ? 'flex-row align-items-center' : 'flex-column')}>
                                        <span style={{ 'backgroundImage': 'url(' + s[control.imageUrl] + ')', 'height': (control.imgheight ? (control.imgheight) : '40px'), 'width': (control.imgwidth ? (control.imgwidth) : '30px') }} className="check-img-img align-self-center"></span>
                                        <span className="check-img-description">
                                            <span className="d-block">{s[control.textfield]}</span>
                                            {s[control.subtextfield] &&
                                                <span className="small text-muted">{s[control.subtextfield]}</span>
                                            }
                                        </span>
                                    </span>
                                    <span className="tic-mark"><i className="fa fa-check-circle fa-lg"></i></span>
                                </label>
                            </div>
                        </div>
                        {control.allowother &&
                            <div className={s[control.textfield] != 'Other' ? 'col col-12 d-none' : 'col col-12'} hidden={!this.state.IsOtherSelected}>
                                {s[control.textfield] == 'Other' &&
                                    <input aria-label={s[control.valuefield]} disabled={this.props.disabled} type="text" value={s[control.valuefield]} className="form-control" onChange={(e) => { apiData[i][control.valuefield] = e.target.value; this.onSelectionsChange("Other", apiData, "Other") }} placeholder="Enter Other value" />
                                }
                            </div>
                        }
                    </React.Fragment>
                )
            }
            if (control.direction != 'displayImage') {
                return (
                    <React.Fragment>
                        <div key={s[control.valuefield]} className={"c-control c-checkbox " + (control.direction == 'horizontal' ? 'c-inline' : '')}>
                            <label>
                                <input aria-label={s[control.valuefield]} disabled={this.props.disabled} className="c-control-input" type="checkbox" value={s[control.valuefield]}
                                    onChange={(e) => { apiData[i].checked = e.target.checked; this.onSelectionsChange(e, apiData, s[control.textfield]) }}
                                    checked={s.checked}
                                    onBlur={() => { this.handleBlur(); }} />
                                <i className="c-control-indicator fa fa-square-o"></i>
                                <span className="c-control-description">{s[control.textfield]}</span>
                            </label>
                        </div>

                        {control.allowother &&
                            <div className={s[control.textfield] != 'Other' ? 'col col-12 d-none' : 'col col-12'} hidden={!this.state.IsOtherSelected}>
                                {s[control.textfield] == 'Other' &&
                                    <input aria-label={s[control.valuefield]} disabled={this.props.disabled} type="text" value={s[control.valuefield]} className="form-control" onChange={(e) => { apiData[i][control.valuefield] = e.target.value; this.onSelectionsChange("Other", apiData, "Other") }} placeholder="Enter Other value" />
                                }
                            </div>
                        }
                    </React.Fragment>
                )
            }
        });


        if (action == 'write') {
            return (
                <div className={(control.showheader == true ? 'card mb-3' : '')} line='checklist 173'>
                    {control.direction == 'displayImage' &&
                        <React.Fragment>
                            {control.showheader == true &&
                                <div className={"card-header d-flex align-items-center pointer " + (this.state.show ? '' : 'border-0')} onClick={() => this.setState({ show: !this.state.show })}>
                                    {control.Panelheader &&
                                        <div>
                                            <span className="d-flex align-items-center">
                                                {(data[control.key] && data[control.key].length > 0) &&
                                                    <i className="text-primary fa fa-check-square-o pr-2"></i>
                                                }
                                                <span className="" dangerouslySetInnerHTML={{ __html: control.Panelheader ? control.Panelheader : '' }} ></span>
                                            </span>
                                        </div>
                                    }
                                    <span className="ml-auto" ><i className={"fa pl-2 " + (this.state.show ? 'fa-angle-up' : 'fa-angle-down')} aria-hidden="true"></i></span>
                                </div>
                            }
                            <div className={(control.showheader == true ? ' card-body pb-1 ' : ' ') + (this.state.show ? ' ' : ' d-none ')}>
                                <div className="form-group">
                                    {control.label.length > 0 &&
                                        <label className={"d-block pb-3 mb-0 " + ((data[control.key] && data[control.key].length > 0) ? 'active' : '')}>
                                            <span>{control.label}</span>
                                            {control.require &&
                                                <sup className="text-danger font-weight-bold">*</sup>
                                            }
                                            {control.showhelptext &&
                                                <span className="custom-tooltip">
                                                    <i className="fa fa-question-circle ml-2 help-text"></i>
                                                    <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                                </span>
                                            }
                                        </label>
                                    }
                                    {control.imageurl &&
                                        <img src={control.imageurl} alt={control.label} width="100" height="100" className="mb-2 img-fluid" />
                                    }
                                    <div className="row check-img-outer">
                                        {checkboxList}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    }
                    {control.direction != 'displayImage' &&
                        <React.Fragment>
                            {control.showheader == true &&
                                <div className={"card-header d-flex align-items-center pointer " + (this.state.show ? '' : 'border-0')} onClick={() => this.setState({ show: !this.state.show })}>
                                    {control.Panelheader &&
                                        <div>
                                            <span className="d-flex align-items-center">
                                                {(data[control.key] && data[control.key].length > 0) &&
                                                    <i className="text-primary fa fa-check-square-o fa-lg pr-2"></i>
                                                }
                                                <span className="" dangerouslySetInnerHTML={{ __html: control.Panelheader ? control.Panelheader : '' }}></span>
                                            </span>
                                        </div>
                                    }
                                    <span className="ml-auto" ><i className={"fa pl-2 " + (this.state.show ? 'fa-angle-up' : 'fa-angle-down')} aria-hidden="true"></i></span>
                                </div>
                            }
                            <div className={(control.showheader == true ? ' card-body pb-1 ' : ' ') + (this.state.show ? ' ' : ' d-none ')}>
                                {control.label.length > 0 &&
                                    <label className={"d-block " + ((data[control.key] && data[control.key].length > 0) ? 'active' : '')}>
                                        <span>{control.label}</span>
                                        {control.require &&
                                            <sup className="text-danger font-weight-bold">*</sup>
                                        }
                                        {control.showhelptext &&
                                            <span className={"custom-tooltip"}>
                                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                            </span>
                                        }
                                    </label>
                                }
                                {control.imageurl &&
                                    <img src={control.imageurl} width="100" height="100" alt={control.label} className="mb-2 img-fluid" />
                                }
                                {checkboxList}
                            </div>
                        </React.Fragment>
                    }
                    <div className={control.showheader == true ? 'px-3 mt--3' : ''}>
                        {shouldMarkError &&
                            <small className={"form-text text-danger " + (!control.description ? 'mb-3' : '')}>
                                {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                            </small>
                        }
                        {control.description &&
                            <div className="form-text mb-3 ">{control.description}</div>
                        }
                    </div>
                </div>
            );
        } else {
            return (
                <div style={{ marginHorizontal: 10, marginBottom: 10 }}>
                    <span style={{ fontSize: 13 }}>{control.label}</span>
                    <span style={{ paddingLeft: 30, fontWeight: 'bold' }}>{this.props.editformdata[control.key]}</span>
                </div>
            );
        }
    }
}

export default connect(
    mapStateToProps, bindAction
)(CheckboxList);